import { render, staticRenderFns } from "./UserPerformanceLogs.vue?vue&type=template&id=de4a4024&scoped=true"
import script from "./UserPerformanceLogs.vue?vue&type=script&lang=js"
export * from "./UserPerformanceLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4a4024",
  null
  
)

export default component.exports